import React, { useEffect, useState } from "react";
import "./wheel.css";
import axios from "axios";
import { useParams } from "react-router-dom";

const WheelJocker = ({ items, onWinItemChange }) => {
  const { qr } = useParams();

  const [selectedItem, setSelectedItem] = useState(null);
  const [rotationCount, setRotationCount] = useState(100);
  const [isProcessing, setIsProcessing] = useState(false);
  const [previousItem, setPreviousItem] = useState(0);
  const [winItem, setWinItem] = useState("");
  const [hasSpun, setHasSpun] = useState(false);
  const [winCount, setWinCount] = useState("");
  const [loading,setLoading]= useState(false);
  const [error, setError] = useState(false);
  const [apiRespons,setApiRespons] = useState("");
  //console.log("apiRespons", apiRespons);

  // const [reversedItems, setReversedItems] = useState();

  const [startTime, setStartTime] = useState(0);
  let durationPerOneRotation = 0.1; // the status depends heavily on the value of durationPerOneRotation: for example, if 20 => not correct
  let spinning = selectedItem !== null ? "spinning" : "";

  //const devApiLink = "http://localhost:4348/api/v1";
  const devApiLink = "https://xl-api.notionspromos.com/api/v1";

  useEffect(()=>{

    if(!qr){
      return
    }
    const getUpdateWinCount = async () => {
      try {
        const response = await axios.get(`${devApiLink}/getWinCount`);
        //const winCountValue = response.data[0]?.winCount; // safely get winCount from first object
        setWinCount(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getUpdateWinCount()

  },[qr])

   useEffect(() => {
      if (!winItem) {
        return;
      }
      localStorage.setItem("winItem", winItem.name);
      localStorage.setItem("gameEnd", new Date().toISOString());
    }, [winItem]);

  const qrCode = qr

  useEffect(() => {
    if (!qrCode) {
      return;
    }
    const getVarifyCode = async () => {
      try {
        await axios
          .get(`${devApiLink}/varifyCode/${qrCode}`)
          .then((response) => {
            setApiRespons(response.data);
          });
      } catch (error) {
        setError("Code not valid or Already Used");
      }
    };
    getVarifyCode();
  }, [qrCode]); 


  // useEffect(() => {
  //   getUpdateWinCount();
  // }, []);

  const handleLottery = async () => {
    setStartTime(Date.now());
    try {
      setIsProcessing(true);
      let _selectedItem = 0;
      setSelectedItem(selectedItem);

      setTimeout(() => {
        setSelectedItem(_selectedItem);
        setRotationCount(100000);
      }, 500);
      // }
    } catch (err) {
      console.log("err", err);
    }
  };

  const wheelVars = {
    "--nb-item": items?.length,
    "--selected-item": selectedItem,
    "--nb-turn": rotationCount,
    "--spinning-duration": `calc(${rotationCount} * ${durationPerOneRotation}s)`,
  };

  const updateCountinFB = async () => {
    const count = {
      newUpdateCount: 1,
    };
    try {
      await axios.put(`${devApiLink}/winCount`, count);
    } catch (error) {
      console.error("Error updating stop count:", error);
    }
  };

  const correstgGuess = async () => {
    const correct = {
      correctCode: qr,
    };
    try {
      await axios.post(`${devApiLink}/correct-guess`, correct);
    } catch (error) {
      console.error("Error updating stop count:", error);
    }
  };

  const handleSetRotationCount = () => {
    const elapsedTime = (Date.now() - startTime) / 1000;

    let passedItems =
      (elapsedTime / durationPerOneRotation) * 8 -
      Math.floor(elapsedTime / durationPerOneRotation) * 8;
    let exactPassedItems = Math.floor(passedItems);

    setRotationCount(0.1);
    let itemWhenClickedStopButton = 9 - exactPassedItems + previousItem;
    if (itemWhenClickedStopButton > 8) itemWhenClickedStopButton -= 8;
    setSelectedItem(itemWhenClickedStopButton);


   updateCountinFB();
   correstgGuess();

    setTimeout(() => {
      setRotationCount(3);
      let selected;

      if (winCount > 0 && winCount % 20000 === 0) {
        selected = items.findIndex((item) => item.name === "Gold Coin");
      } else if (winCount > 0 && winCount % 19900 === 0) {
        selected = items.findIndex((item) => item.name === "Electric scooter");
      } else if (winCount > 0 && winCount % 19500 === 0) {
        selected = items.findIndex((item) => item.name === "Mini Laptop");
      } else if (winCount > 0 && winCount % 19750 === 0) {
        selected = items.findIndex((item) => item.name === "Mobile Phone");
      } else if (winCount > 0 && winCount % 19999 === 0) {
        selected = items.findIndex((item) => item.name === "Play Station");
      } else if (winCount > 0 && winCount % 4999 === 0) {
        selected = items.findIndex((item) => item.name === "Smart watch");
      } else if (winCount > 0 && winCount % 14 === 0) {
        selected = items.findIndex((item) => item.name === "Amazon gift card");
      } else {
        selected = items.findIndex((item) => item.name === "No-luck");
      }

      setSelectedItem(selected);
      setPreviousItem(selected);
      const newWinItem = items[selected];
      setWinItem(newWinItem);
      if (onWinItemChange) {
        onWinItemChange(newWinItem); // Notify parent of the new winItem
      }
      setIsProcessing(false);
    }, 5);
  };

  const lostGame = localStorage.getItem("LocalWinItem");
  //console.log(lostGame);

  return (
    items &&
    items.length > 0 && (
      <>
        <div className="wheel_wrp">
          <div className="wheel_wrp_head">
            {/* <img src={require("../../img/chocodate.webp")} alt="" /> */}
            <div className="_gift">
              <img src={require("../../img/gift.png")} alt="" />
            </div>
          </div>
          <div className="border">
            <div className="wheel-container">
              <div className={`wheel ${spinning}`} style={wheelVars}>
                {items.map((item, index) => (
                  <div
                    className="choco_wheel-item"
                    key={index}
                    style={{ "--item-nb": index }}
                  >
                    <img
                      src={item.img}
                      alt={item.name}
                      style={{
                        width: "70px",
                        height: "auto",
                        marginLeft: "10px",
                      }}
                    />
                    {/* <span>{item.name}</span> */}
                  </div>
                ))}
              </div>
              <div className="__logo">
                <img src={require("../../img/logo.png")} alt="" />
              </div>
              <div className="border_img">
                {isProcessing ? (
                  <img src={require("../../img/border.gif")} alt="" />
                ) : (
                  <img src={require("../../img/border.png")} alt="" />
                )}
              </div>
              <div className="blackBorder"></div>
            </div>
          </div>

          <div className="wrp_btn">
            {isProcessing ? (
              // <img src={require("../../img/b_utton.png")} alt="" />
              <img src={require("../../img/button.gif")} alt="" />
            ) : (
              <img src={require("../../img/button.gif")} alt="" />
            )}
            {!isProcessing ? (
              <span
                className="sp_btn"
                onClick={() => {
                  if (!hasSpun) {
                    handleLottery();
                    setIsProcessing(true);
                    setHasSpun(true); // Ensure only one spin per session
                  }
                }}
                disabled={isProcessing || hasSpun}
              >
                <h2>Spin & Win</h2>
              </span>
            ) : (
              <span
                className="sp_btn"
                onClick={() => {
                  handleSetRotationCount();
                  setIsProcessing(false); // Allow stopping the spin
                }}
                disabled={!isProcessing}
              >
                <h2>Stop</h2>
              </span>
            )}
          </div>
          {/* <div className="_code">
            <p>
              Your Code: <strong>{qrCode}</strong>{" "}
            </p>
          </div> */}
        </div>
      </>
    )
  );
};

export default WheelJocker;
